import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../../../routes/routes';

interface SurveyDetailTabsProps {
  surveyId: number | string;
}

const tabs = [
  { label: 'Settings', href: ROUTES.survey.settings },
  { label: 'Quiz', href: ROUTES.survey.quiz },
  { label: 'Statistics', href: ROUTES.survey.statistics },
  { label: 'Answers', href: ROUTES.survey.answers },
];

export function SurveyDetailTabs({ surveyId }: SurveyDetailTabsProps) {
  const location = useLocation();

  return (
    <nav className="nav nav-tabs mb-3" aria-label="Survey detail navigation">
      {tabs.map((tab) => {
        const href = tab.href(surveyId);
        const isActive = location.pathname === href;
        return (
          <Link key={tab.label} className={`nav-link${isActive ? ' active' : ''}`} to={href}>
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
